import React from 'react';

import ConstantContact from '../../assets/images/logowall/Constant-Contact.png';
import Hootsuite from '../../assets/images/logowall/Hootsuite.png';
import HP from '../../assets/images/logowall/HP.png';
import Onecom from '../../assets/images/logowall/Onecom.png';
import Reuters from '../../assets/images/logowall/Reuters.png';
import Semrush from '../../assets/images/logowall/Semrush.png';
import Shopify from '../../assets/images/logowall/Shopify.png';
import Shutterfly from '../../assets/images/logowall/Shutterfly.png';
import SproutSocial from '../../assets/images/logowall/Sprout-Social.png';

import * as classes from './style.module.scss';

export const LogoWall: React.FC = () => {
  return (
    <div className={classes.mainWrapper}>
      <div className={classes.textWrapper}>
        <h3 className={classes.primaryText}>500M+</h3>
        <div className={classes.text}>
          video and photo creations are powered by IMG.LY every month
        </div>
      </div>
      <div className={classes.logoWrapper}>
        <img className={classes.logo} src={HP} alt="HP logo" />
        <img className={classes.logo} src={Shopify} alt="Shopify logo" />
        <img className={classes.logo} src={Reuters} alt="Reuters logo" />
        <img className={classes.logo} src={Hootsuite} alt="Hootsuite logo" />
        <img className={classes.logo} src={Semrush} alt="Semrush logo" />
        <img className={classes.logo} src={Shutterfly} alt="Shutterfly logo" />
        <img
          className={classes.logo}
          src={SproutSocial}
          alt="Sprout Social logo"
        />
        <img className={classes.logo} src={Onecom} alt="One.com logo" />
        <img
          className={classes.logo}
          src={ConstantContact}
          alt="Constant Contact logo"
        />
      </div>
    </div>
  );
};
